module.exports = __webpack_public_path__ + "img/td_btn.b00b8732.png";